angular.module('gym.components').directive('userMfa', function() {
  return {
    restrict: 'E',
    template: require('templates/components/profile/userMfa.html.slim'),
    scope: {
      setTab: '='
    },
    controller: ["$scope", "$rootScope", "ReactModal", "MasqueradingService", "$window", "$http", "flash", function($scope, $rootScope, ReactModal, MasqueradingService, $window, $http, flash) {
      var updateIsDisableBlocked, updateIsEnableBlocked;
      $scope.gym = $rootScope.gym;
      $scope.isAccountOwner = window.currentUser.account_owner;
      $scope.setProfileTab = function() {
        return $scope.setTab('profile');
      };
      $scope.isMasquerading = MasqueradingService.isMasquerading();
      $scope.user = window.currentUser;
      $scope.isEnableBlocked = function() {
        return !$scope.data || $scope.isLoading;
      };
      updateIsDisableBlocked = function() {
        return $scope.isDisableBlocked = !$scope.data || $scope.isLoading || ($scope.data.multi_factor_auth_required_default && !$scope.isAccountOwner);
      };
      updateIsEnableBlocked = function() {
        return $scope.isEnableBlocked = !$scope.data || $scope.isLoading;
      };
      $scope.$watch('data', function() {
        updateIsDisableBlocked();
        return updateIsEnableBlocked();
      });
      $scope.$watch('isAccountOwner', function() {
        return updateIsDisableBlocked();
      });
      $scope.confirmUser = function() {
        return ReactModal.open({
          component: 'ManageMfaModal',
          props: {
            mode: 'confirm_password'
          }
        });
      };
      $scope.enableMfa = function() {
        if (!$scope.isMasquerading) {
          return ReactModal.open({
            component: 'ManageMfaModal',
            props: {
              mfaAction: 'enable',
              mode: 'confirm_password',
              isSocialLogin: $scope.user.ssi_enabled
            }
          });
        }
      };
      $scope.loadStatus = function() {
        var url;
        url = `/gyms/${$scope.gym.id}/profile/multi_factor_auth_status`;
        return $http.get(url).then(function(response) {
          return $scope.data = response.data;
        });
      };
      $scope.loadStatus();
      return $scope.enable = function() {
        var url;
        url = "/users/enable_twilio_verify";
        return $http.post(url).then(function() {
          return $window.location.reload();
        }, function() {
          return flash.error = "An error occurred while enabling multi-factor authentication for your account.";
        });
      };
    }]
  };
});
